import { Helmet } from "react-helmet-async";

const SITE_URL = "https://managertable.com";
const DEFAULT_IMAGE =
  "https://nnrbcjxsgyghtolpdnti.supabase.co/functions/v1/og-image";

interface SeoProps {
  title: string;
  description: string;
  /** Route path, e.g. "/rankings" */
  path: string;
  image?: string;
  /** Optional JSON-LD object rendered as structured data */
  jsonLd?: Record<string, unknown> | Record<string, unknown>[];
  noIndex?: boolean;
}

export function Seo({ title, description, path, image, jsonLd, noIndex }: SeoProps) {
  const url = `${SITE_URL}${path}`;
  const ogImage = image || DEFAULT_IMAGE;

  return (
    <Helmet>
      <title>{title}</title>
      <meta name="description" content={description} />
      <link rel="canonical" href={url} />
      {noIndex && <meta name="robots" content="noindex" />}

      <meta property="og:title" content={title} />
      <meta property="og:description" content={description} />
      <meta property="og:url" content={url} />
      <meta property="og:type" content="website" />
      <meta property="og:image" content={ogImage} />

      <meta name="twitter:card" content="summary_large_image" />
      <meta name="twitter:title" content={title} />
      <meta name="twitter:description" content={description} />
      <meta name="twitter:image" content={ogImage} />

      {(Array.isArray(jsonLd) ? jsonLd : jsonLd ? [jsonLd] : []).map((obj, i) => (
        <script key={i} type="application/ld+json">{JSON.stringify(obj)}</script>
      ))}
    </Helmet>
  );
}

export default Seo;
